import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import fmt from 'utils/fmt';
import StatusBar from 'components/StatusBar';
import Footer from 'components/Footer';
import LeftPanel from 'components/LeftPanel';
import { KioOrderToStts, OrderCountToStts, OrderAcceptWaiting, UpdateOrderStts, CancelPay } from 'graphql/order';
import { useQuery, useMutation, useSubscription } from 'react-apollo';
import _ from 'lodash';
import Modal from 'components/Modal';
import MenuPanel from 'components/MenuPanel';
import ConfirmAlert from './ConfirmAlert';
import ChangeStatus from './ChangeStatus';
import OrderDetail from './OrderDetail';
import SettingPrinter from 'screens/SettingPrinter';
import SettingMy from 'screens/SettingMy';
import { getCurrentShopInfo, makeNotification } from 'shared/Common';
import { printOrderDetail } from 'utils/printer';
import ShopList from 'screens/ShopList';
import { readSettingFile } from 'shared/Settings';

let modalInnerView = null;
let modalTitle = '';

let modalWidth = 'w-full h-full sm:h-auto sm:w-1/2';

const getSsoApiUrl = () => {
  if (process.env.REACT_APP_SSO_API_URL) return process.env.REACT_APP_SSO_API_URL.replace(/\/$/, '');

  const apiEndpoint = process.env.REACT_APP_END_POINT || '';
  const apiHost = apiEndpoint.replace(/\/graphql\/?$/, '');
  return apiHost ? `https://${apiHost}` : '';
};

const getCeoWebUrl = () => {
  if (process.env.REACT_APP_CEO_WEB_URL) return process.env.REACT_APP_CEO_WEB_URL.replace(/\/$/, '');

  const apiEndpoint = process.env.REACT_APP_END_POINT || '';
  return apiEndpoint.includes('kiodev') ? 'https://kiodevceoadm.h-brick.com' : 'https://kioceoadm.h-brick.com';
};

export default function Main(props) {
  const history = useHistory();

  useEffect(() => {
    const token = window.localStorage.getItem('token');
    if (!token) {
      history.replace('/login');
    }
  }, [history]);

  const [currentShop, setCurrentShop] = useState(() => getCurrentShopInfo());
  const SHOP_ID = currentShop ? currentShop.shopId : null;

  const [visibleModal, setVisibleModal] = useState(false);
  const [menuPanelOpen, setMenuPanelOpen] = useState(false);
  const [ordrStts, setOrdrStts] = useState('3');
  const [subscriptionArr, setSubscriptionArr] = useState([]);
  const [page, setPage] = useState(1);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [hasMoreOrders, setHasMoreOrders] = useState(true);
  const LIMIT = 20;

  const refetchQueries = async () => {
    setSubscriptionArr([]);
    setHasMoreOrders(true);
    await countQueryRes.refetch({ shopId: SHOP_ID });
    await refetch({ shopId: SHOP_ID, limit: LIMIT, offset: 0 });
  };

  const { data, refetch, fetchMore } = useQuery(KioOrderToStts, {
    fetchPolicy: 'network-only',
    variables: { shopId: SHOP_ID, ordrStts: ordrStts, limit: LIMIT, offset: 0 },
    skip: !SHOP_ID,
    //pollInterval: 10000,
  });

  const countQueryRes = useQuery(OrderCountToStts, {
    fetchPolicy: 'no-cache',
    variables: { shopId: SHOP_ID },
    skip: !SHOP_ID,
    //pollInterval: 10000,
  });

  useEffect(() => {
    setSubscriptionArr([]);
    setHasMoreOrders(true);
  }, [SHOP_ID]);

  const [updateOrderStts] = useMutation(UpdateOrderStts, {
    onCompleted(data) {
      if (data && data.updateOrderStts) {
        refetchQueries();
      }
    },
  });

  const subscriptionRes = useSubscription(OrderAcceptWaiting, {
    variables: { shopId: SHOP_ID },
    skip: !SHOP_ID,
    onSubscriptionData(opts) {
      const subscriptionOrder = opts.subscriptionData.data.orderAcceptWaiting;
      countQueryRes.refetch({ shopId: SHOP_ID });
      const settings = readSettingFile();
      if (settings.autoPrint) {
        printOrderDetail(subscriptionOrder);
      }

      if (settings.autoAccept) {
        updateOrderStatus(subscriptionOrder);
      }

      makeNotification('#', '주문', '주문 접수 알림');
    },
  });

  let _data;
  if (subscriptionRes.data && subscriptionRes.data.orderAcceptWaiting) {
    let subscriptionData = subscriptionRes.data.orderAcceptWaiting;
    const hasData = _.filter(data?.kioOrderToStts, { ordrNo: subscriptionData.ordrNo }).length > 0;
    if (Number(subscriptionData.shopId) === Number(SHOP_ID) && !_.some(subscriptionArr, { ordrNo: subscriptionData.ordrNo }) && !hasData) {
      setSubscriptionArr((orders) => [subscriptionData, ...orders]);
    }
  }

  if (data && data.kioOrderToStts) {
    _data = data.kioOrderToStts;
    const pendingSubscriptionOrders = _.reject(subscriptionArr, (subscriptionOrder) =>
      _.some(data.kioOrderToStts, { ordrNo: subscriptionOrder.ordrNo }),
    );
    if (pendingSubscriptionOrders.length > 0) {
      _data = _.concat(pendingSubscriptionOrders, _data);
    }
  }

  useEffect(() => {
    console.log('kioOrderToStts display count:', _data ? _data.length : 0);
  }, [_data]);

  // const completedPaymentOrders = _.filter(
  //   _data,
  //   (order) =>
  //     Number(order.shopId) === Number(SHOP_ID) &&
  //     Number(order.payYn) === 1 &&
  //     !['C', 'X', 'Y', 'M'].includes(order.ordrStts),
  // );
  // const completedPaymentAmount = _.sumBy(completedPaymentOrders, (order) => Number(order.payAmt) || 0);

  let filteredData;
  if (ordrStts === '3') {
    // 접수 탭: 상태 '3' 표시
    filteredData = _.filter(
      _data,
      (order) => Number(order.shopId) === Number(SHOP_ID) && ['3', '4'].includes(order.ordrStts)
    );
  } else if (ordrStts === '4'){
    // [완료/기타 탭] 상태가 '3', '4', 'C'가 아닌 주문만 필터링
    filteredData = _.filter(_data, (order) => {
      return (
        Number(order.shopId) === Number(SHOP_ID) &&
        !['3', '4', 'C'].includes(order.ordrStts)
      );
    });
  }
  
  // if (ordrStts === '3' || ordrStts === '4') {
  //   filteredData = _.filter(_data, (order) => Number(order.shopId) === Number(SHOP_ID) && order.ordrStts === ordrStts);
  // } else {
  //   filteredData = _.filter(_data, function (order) {
  //     return Number(order.shopId) === Number(SHOP_ID) && order.ordrStts !== '3' && order.ordrStts !== '4' && order.ordrStts !== 'C';
  //   });
  // }

  const showOrderDetailModal = (orderItem) => {
    modalWidth = 'w-full h-full sm:h-auto sm:w-5/6 sm:max-w-4xl';
    modalTitle = '주문상세';
    modalInnerView = <OrderDetail refetchQueries={refetchQueries} orderItem={orderItem} onClose={() => setVisibleModal(false)} />;
    setVisibleModal(true);
  };

  const showModal = async (orderItem) => {
    modalWidth = 'w-11/12 sm:w-1/2 sm:max-w-lg';
    let titles;
    if (orderItem.ordrStts === 'X' || orderItem.ordrStts === 'Y' || orderItem.ordrStts === 'M') {
      return;
    }

    switch (orderItem.ordrStts) {
      case '3':
        modalTitle = '주문상태 변경';
        titles = ['주문접수'];
        break;
      case '4':
        modalTitle = '주문상태 변경';
        titles = ['주문완료', '주문취소'];
        break;
      case '5':
        modalTitle = '주문취소';
        break;
      default:
        break;
    }

    const onBlueBtnPressed = async (item) => {
      await updateOrderStatus(item);
    };

    const onRedBtnPressed = async (item) => {
      await updateOrderStatus(item, true);
    };

    if (orderItem.ordrStts === '3' || orderItem.ordrStts === '4') {
      modalInnerView = (
        <ChangeStatus
          item={orderItem}
          titles={titles}
          onClose={() => setVisibleModal(false)}
          onBlueBtnPressed={onBlueBtnPressed}
          onRedBtnPressed={onRedBtnPressed}
        />
      );
    } else if (orderItem.ordrStts === '5') {
      modalInnerView = (
        <ConfirmAlert
          item={orderItem}
          text="정말 결제를 취소하시겠습니까?"
          onClose={() => setVisibleModal(false)}
          onConfirm={onRedBtnPressed}
        />
      );
    } else {
      modalInnerView = null;
    }

    setVisibleModal(true);
  };

  const updateOrderStatus = async (orderItem, isCancel) => {
    try {
      let _ordrStts;
      if (isCancel) {
        switch (orderItem.ordrStts) {
          case '3':
            _ordrStts = 'Y';
            break;
          case '4':
          case '5':
            _ordrStts = 'X';
            break;
          default:
            break;
        }
      } else {
        switch (orderItem.ordrStts) {
          case '3':
            _ordrStts = '4';
            break;
          case '4':
            _ordrStts = '5';
            break;
          default:
            break;
        }
      }

      if (_ordrStts) {
        const variables = {
          ordrNo: orderItem.ordrNo,
          ordrStts: _ordrStts,
        };
        await updateOrderStts({ variables });
      }
    } catch (err) {
      console.error(err.stack);
    }
  };

  const leftPanelBtnPressed = async (_ordrStts) => {
    setSubscriptionArr([]);
    setMenuPanelOpen(false);
    setPage(1); // 탭 변경 시 페이지 초기화
    setHasMoreOrders(true); // 탭 변경 시 더 보기 상태 초기화 

    try {
      setOrdrStts(_ordrStts);
      await refetchQueries({ shopId: SHOP_ID, ordrStts: _ordrStts, limit: LIMIT, offset: 0 });
    } catch (err) {
      console.error(err.stack);
    }
    //setOrdrStts(_ordrStts);
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    // 스크롤이 바닥에 거의 닿았을 때(예: 하단 20px 전)
    if (scrollTop + clientHeight >= scrollHeight - 20) {
      // 스크롤이 바닥에 도달하면 다음 페이지를 불러오는 로직 추가
      loadMoreData();
    }
  };

  const loadMoreData = async () => {
    if (!data || !data.kioOrderToStts || isFetchingMore || !hasMoreOrders) return;

    const currentLength = data.kioOrderToStts.length;
    setIsFetchingMore(true);

    try {
      const result = await fetchMore({
        variables: {
          shopId: SHOP_ID,
          ordrStts: ordrStts,
          limit: LIMIT,
          offset: currentLength,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult || !fetchMoreResult.kioOrderToStts.length) return previousResult;

          return {
            kioOrderToStts: _.uniqBy([...previousResult.kioOrderToStts, ...fetchMoreResult.kioOrderToStts], 'ordrNo'),
          };
        },
      });

      if (!result.data.kioOrderToStts || result.data.kioOrderToStts.length < LIMIT) {
        setHasMoreOrders(false);
      }
    } catch (err) {
      console.error('Failed to load more orders:', err);
    } finally {
      setIsFetchingMore(false);
    }
  };

  const stopPropagation = (e) => {
    let _event = e;
    if (!e) _event = window.event;
    _event.cancelBubble = true;
    if (_event.stopPropagation) _event.stopPropagation();
  };

  const renderAcceptWaiting = (v, i, a) => {
    const ordrItemDisp = (ordrItems) => {
      return ordrItems.map((v, i, a) => {
        let itemQty = v.ordrItemQty;
        let itemNm = `${v.ordrItemNm} ${v.ordrItemQty}개` + (i === a.length - 1 ? '' : ' / ');

        return { itemNm, itemQty };
      });
    };

    const getButtonText = (_ordrStts) => {
      let _buttonText;
      let _buttonColor;
      switch (_ordrStts) {
        case '3':
          _buttonText = '접수하기';
          _buttonColor = 'primary';
          break;
        case '4':
          _buttonText = '완료하기';
          _buttonColor = 'secondary';
          break;
        case '5':
          _buttonText = '취소하기';
          _buttonColor = 'alert';
          break;
        case 'X':
        case 'Y':
        case 'M':
          _buttonText = '취소완료';
          _buttonColor = 'cust-medium-gray';
          break;
        default:
          break;
      }

      return { text: _buttonText, color: _buttonColor };
    };

    let itemInfo = ordrItemDisp(v.ordrItems);
    let itemName = '';
    let menuCount = 0;
    for (let i = 0; i < itemInfo.length; i++) {
      itemName += itemInfo[i].itemNm;
      menuCount += itemInfo[i].itemQty;
    }
    const tableNumStr = v.tblNm.padStart(2, '0');
    let buttonInfo = getButtonText(v.ordrStts);

    return (
      <div
        key={`acceptWaiting-${i}`}
        className="w-full min-w-0 flex flex-col md:flex-row md:h-32 p-3 md:pl-4 border-b border-gray-400 cursor-pointer hover:bg-gray-100 transition-colors gap-3 md:gap-0 overflow-x-hidden"
        onClick={() => {
          showOrderDetailModal(v);
        }}
      >
        <div className="flex flex-row md:flex-col md:w-24 items-center justify-between md:justify-center shrink-0">
          <span className="text-base md:text-lg font-bold">{fmt.getLocalOnlyTime(v.ordrAt)}</span>
          <span className="inline-flex justify-center items-center px-2.5 py-1 md:w-12 md:h-8 text-white bg-secondary text-xs md:text-sm font-semibold rounded md:rounded-none md:mt-2">
            {v.ordrType}
          </span>
        </div>

        <div className="flex flex-col w-full justify-center md:pl-8 min-w-0">
          <span className="text-base md:text-lg font-bold">접수번호 {v.acceptNum}</span>
          <span className="text-xs md:text-sm text-gray-700 truncate my-0.5">{itemName}</span>
          <span className="text-sm md:text-lg font-bold text-gray-900 truncate">
            테이블 {tableNumStr} / 메뉴 {menuCount}개 / {fmt.getCurrency(v.payAmt)} 원
          </span>
        </div>

        <div className="flex flex-row gap-2 w-full md:w-96 md:shrink-0 items-center">
          <div className="flex-1 h-10 md:h-full px-0 md:px-2">
            <button
              className="w-full h-full font-bold text-black bg-white border border-primary rounded md:rounded-none hover:bg-gray-50 transition-all text-xs md:text-sm"
              onClick={(e) => {
                printOrderDetail(v);
                stopPropagation(e);
              }}
            >
              주문표 인쇄
            </button>
          </div>

          <div className="flex-1 h-10 md:h-full px-0 md:px-2">
            <button
              className={`w-full h-full font-bold text-white border border-${buttonInfo.color} bg-${buttonInfo.color} rounded md:rounded-none hover:opacity-90 transition-all text-xs md:text-sm`}
              onClick={async (e) => {
                showModal(v);
                stopPropagation(e);
              }}
            >
              {buttonInfo.text}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const settingBtnPressed = () => {
    modalWidth = 'w-full h-full sm:h-auto sm:w-1/2 sm:max-w-xl';
    modalTitle = '프린터 설정';
    modalInnerView = <SettingPrinter onClose={() => setVisibleModal(false)} />;
    setVisibleModal(true);
  };

  const settingMyBtnPressed = () => {
    modalWidth = 'w-full h-full sm:h-auto sm:w-1/2 sm:max-w-md';
    modalTitle = '내 설정';
    modalInnerView = <SettingMy onClose={() => setVisibleModal(false)} />;
    setVisibleModal(true);
  };

  const shopSelectBtnPressed = () => {
    modalWidth = 'w-11/12 sm:w-1/2 sm:max-w-md';
    modalTitle = '가게 목록';
    modalInnerView = <ShopList onShopSelect={setCurrentShop} onClose={() => setVisibleModal(false)} />;
    setVisibleModal(true);
  };

  const menuListBtnPressed = () => {
    setMenuPanelOpen((isOpen) => !isOpen);
  };

  const administratorBtnPressed = async () => {
    // 비동기 SSO 요청 전에 창을 열어야 브라우저의 팝업 차단을 피할 수 있다.
    const ceoWindow = window.open('', '_blank');

    try {
      if (!ceoWindow) throw new Error('관리자 페이지 창이 차단되었습니다. 팝업 차단을 해제해 주세요.');

      const token = window.localStorage.getItem('token');
      const ssoApiUrl = getSsoApiUrl();
      if (!token || !ssoApiUrl) throw new Error('SSO 연결 정보를 확인할 수 없습니다.');

      const response = await fetch(`${ssoApiUrl}/api/join/createPosSsoCode`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: token,
        },
        // 현재 선택 매장이 로그인한 대표자에게 연결된 경우에만 SSO를 허용한다.
        body: JSON.stringify({ shopId: SHOP_ID }),
      });
      const result = await response.json();
      if (!response.ok || result.code !== '0000' || !result.ssoCode) {
        throw new Error(result.message || 'SSO 코드 발급에 실패했습니다.');
      }

      ceoWindow.location.replace(
        `${getCeoWebUrl()}/login?ssoCode=${encodeURIComponent(result.ssoCode)}&redirect=${encodeURIComponent('/salestotal')}`,
      );
    } catch (err) {
      if (ceoWindow && !ceoWindow.closed) ceoWindow.close();
      console.error('Failed to start CEO SSO:', err);
      alert(err.message || '관리자 페이지로 이동하지 못했습니다.');
    }
  };

  const totalSummary = _.find(countQueryRes.data?.orderCountToStts, { ordrStts: '0' }) || { count: 0, totalAmount: 0 };
  //console.log("totalSummary : ",  totalSummary);

  return (
    <div
      className="flex flex-col bg-cust-gray w-full overflow-x-hidden overflow-y-hidden"
      style={{ minHeight: '100vh', height: '100dvh' }}
    >
      <StatusBar
        currentShop={currentShop}
        shopSelectBtnPressed={shopSelectBtnPressed}
        menuListBtnPressed={menuListBtnPressed}
        administratorBtnPressed={administratorBtnPressed}
        settingBtnPressed={settingBtnPressed}
        settingMyBtnPressed={settingMyBtnPressed}
        completedPaymentCount={Number(totalSummary.count) || 0}
        completedPaymentAmount={Number(totalSummary.totalAmount) || 0}
      />
      <div className="flex flex-col md:flex-row w-full flex-1 min-h-0 bg-cust-gray overflow-x-hidden">
        <LeftPanel
          data={countQueryRes.data}
          active={parseInt(ordrStts) - 3}
          onClickFunc={leftPanelBtnPressed}
        />
        <div className="flex-1 overflow-y-auto overflow-x-hidden min-h-0" onScroll={handleScroll}>
          {filteredData && filteredData.map(renderAcceptWaiting)}
        </div>
        {menuPanelOpen && <MenuPanel shopId={SHOP_ID} onClose={() => setMenuPanelOpen(false)} />}
      </div>
      <Modal
        innerWidth={modalWidth}
        title={modalTitle}
        hasCloseBtn
        isOpen={visibleModal}
        onRequestClose={() => setVisibleModal(false)}
      >
        {modalInnerView && modalInnerView}
      </Modal>
      <Footer />
    </div>
  );
}